<div class="custom-exemption-form">
    <form [formGroup]="form" class="space-y-4">
        <!-- License Plate Input with Add Button -->
        <div class="flex gap-2 items-start">
            <mat-form-field appearance="fill" class="flex-1">
                <mat-label>License Plate Number</mat-label>
                <input matInput formControlName="licensePlateInput" placeholder="Enter license plate"
                    (keyup.enter)="addLicensePlate()" [disabled]="isAddingPlate()">
                <mat-hint>Enter a license plate and click Add to register/fetch it</mat-hint>
            </mat-form-field>
            <button mat-raised-button color="primary" type="button" (click)="addLicensePlate()"
                [disabled]="isAddingPlate()" class="mt-1">
                @if (isAddingPlate()) {
                <mat-spinner diameter="20"></mat-spinner>
                } @else {
                <ng-container>
                    <mat-icon>add</mat-icon>
                    Add
                </ng-container>
                }
            </button>
        </div>

        <!-- License Plates Chips Display -->
        @if (licensePlates().length > 0) {
        <div class="bg-gray-50 rounded-lg p-3">
            <div class="text-sm text-gray-600 mb-2">Added License Plates:</div>
            <mat-chip-set>
                @for (plate of licensePlates(); track plate.id) {
                <mat-chip (removed)="removeLicensePlate(plate)">
                    {{ plate.fullNumber }}
                    <button matChipRemove aria-label="Remove license plate">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
                }
            </mat-chip-set>
        </div>
        }

        @if (licensePlates().length === 0) {
        <div class="text-sm text-orange-600 flex items-center gap-1">
            <mat-icon class="text-base">warning</mat-icon>
            At least one license plate is required
        </div>
        }

        <!-- Parking Zones Multi-Select -->
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Parking Zones</mat-label>
            <mat-select formControlName="availableForParkingZones" multiple>
                @for (zone of availableZones(); track zone.id) {
                <mat-option [value]="zone.id">{{ zone.name }}</mat-option>
                }
            </mat-select>
            <mat-hint>Optional: leave empty for the whole space</mat-hint>
        </mat-form-field>

        <!-- Availability Period -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Available From</mat-label>
                <input matInput [matDatepicker]="fromPicker" formControlName="availableFrom">
                <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker></mat-datepicker>
                <mat-hint>Optional: Leave empty for immediate availability</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Available To</mat-label>
                <input matInput [matDatepicker]="toPicker" formControlName="availableTo">
                <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                <mat-datepicker #toPicker></mat-datepicker>
                <mat-hint>Optional: Leave empty for no end date</mat-hint>
            </mat-form-field>
        </div>

        <!-- Do not record -->
        <div class="flex items-start justify-between gap-4 rounded-xl border border-slate-200 bg-slate-50 p-3">
            <div>
                <p class="text-sm font-medium text-slate-800">Do not record parking processes</p>
                <p class="text-xs text-slate-500 mt-0.5">The barrier still opens and the display still
                    shows a welcome, but these vehicles leave no parking process — so they stay out of
                    reports and occupancy figures. Use for police and emergency fleets.</p>
            </div>
            <mat-slide-toggle formControlName="skipProcessRecording" color="primary"></mat-slide-toggle>
        </div>

        <!-- Info Box -->
        <div class="bg-green-50 border border-green-200 rounded-lg p-3">
            <div class="flex items-start gap-2">
                <mat-icon class="text-green-600 text-sm">info</mat-icon>
                <div class="text-sm text-green-800">
                    <p><strong>Custom Exemption:</strong> Specifically listed license plates will be exempted from
                        parking fees during the specified period.</p>
                </div>
            </div>
        </div>
    </form>
</div>